import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { ReactComponent as ExampleIcon } from '../../images/Example.svg'
import UseTranslation from '../../hooks/UseTranslation'
import TitleWithIcon from '../../components/Cards/helpers/TitleWithIcon'
import CardWithSpace from '../../components/Cards/CardWithSpace'
import { ReactComponent as AttachmentIcon } from '../../images/DownloadIcon.svg'
import SvgIconSize from '../../components/Cards/helpers/SvgIconSize'

const ExampleTemplate = () => {
  const { t } = UseTranslation()
  return (
    <Box sx={styles.tipsContainer}>
      <TitleWithIcon
          title={t?.['Example Template']}
          icon={<ExampleIcon />}
          iconSize="lg"
          textVariant="heading3"
          customStyle={styles.tipsTitle}
        />
      <Box sx={styles.tipsSubTile}>
        <Typography variant='heading7' sx={styles.tipsSubTitleText}>
          {t?.['After downloading the template, review the example data, then delete all content (including headers) before preparing your Data.']}
        </Typography>
      <Box
  component="a"
  href="/template/ImportUserRolesTemplate.xlsx"
  download="ImportUserRolesTemplate.xlsx"
  sx={styles.tipsTitleTextContainer}
        >
          <SvgIconSize
          icon={<AttachmentIcon />}
          size={20}
          color="#29cc8b"
        />
          <Typography variant='heading6'>{t?.['Download Template']}</Typography>
      </Box>
      </Box>
      <Box sx={{ ...styles.tipsTableWrapper }}>
        <Box sx={styles.tipsTable}>
          <Box sx={{ minWidth: '800px' }}>
        <CardWithSpace sx={styles.tipsTableRowHeader}>
          <Typography variant='heading5' sx={styles.tipsTableRowHeaderText}>{t?.['Email Address']}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowHeaderText}>{t?.['Employee Code']}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowHeaderText}>{t?.Module}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowHeaderText}>{t?.Role}</Typography>
        </CardWithSpace>
        <CardWithSpace sx={styles.tipsTableRowData}>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>example@example.com</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>123456</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            Self Service
          </Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            Self
          </Typography>
        </CardWithSpace>
        <CardWithSpace sx={styles.tipsTableRowData}>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>example2@example.com</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}></Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.EDS}
          </Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            Employee
          </Typography>
        </CardWithSpace>
        <CardWithSpace sx={styles.tipsTableRowData}>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}></Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>A12345</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            EDS
          </Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            Appraiser
          </Typography>
        </CardWithSpace>
        </Box>
        </Box>
        </Box>
    </Box>
  )
}

const styles = {
  tipsContainer: {
    marginBlock: '20px',
    paddingBottom: { xs: '50px', sm: '0px' },
  },
  tipsTitle: {
    gap: '5px',
    marginBottom: '15px !important',
  },
  tipsSubTile: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    marginTop: { xs: '25px', md: '0px' },
  },
  tipsTitleTextContainer: {
    position: { xs: 'absolute', md: 'static' },
    right: '0',
    top: '-30px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
    color: 'primary.main',
    '& span': {
      textDecoration: 'underline',
      marginBottom: '10px',
    },
  },
  mandatoryIcon: {
    gap: '5px',
  },
  tipsSubTitleText: {
    color: 'text.disabled',
    paddingLeft: { xs: '0px', md: '40px' },
  },
  tipsTableRowHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: 'primary.main',
    marginTop: '15px',
    borderRadius: '8px',
    height: '40px',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  tipsTableWrapper: {
    position: 'relative',
  },
  tipsTable: {
    width: '100%',
    overflowX: 'auto',
  },
  tipsTableRowHeaderText: {
    color: 'text.main',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minWidth: { xs: '200px', md: 'unset' },
    '&:nth-of-type(1)': { flex: '1.5' },
    '&:nth-of-type(2)': { flex: '2' },
    '&:nth-of-type(3)': { flex: '3' },
    '&:nth-of-type(4)': { flex: '3' },
  },
  tipsTableRowData: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
    boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.1)',
    marginTop: '15px',
    borderRadius: '8px',
    height: '55px',
    backgroundColor: 'background.paper',
  },
  tipsTableRowDataText: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minWidth: { xs: '200px', md: 'unset' },
    '&:nth-of-type(1)': { flex: '1.5' },
    '&:nth-of-type(2)': { flex: '2' },
    '&:nth-of-type(3)': { flex: '3' },
    '&:nth-of-type(4)': { flex: '3' },
  },
}
export default ExampleTemplate;
